import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { fontSize } from "../../component/theme/fontSize";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { convertFromHTML, ContentState, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

function UniversityOverviewSection({ data }) {
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  useEffect(() => {
    console.log(data)
    if (data) {
      const contentBlock = htmlToDraft(data);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks,
          contentBlock.entityMap
        );
        const newEditorState = EditorState.createWithContent(contentState);
        setEditorState(newEditorState);
      }
    }
  }, [data]);

  return (
    <div>
      {/* <Typography
        component="div"
        fontSize={fontSize.h3.small}
        fontFamily={FontFamily.Lato}
        fontWeight={fontWeight.W600}
      > */}
      {/* <Editor
        editorState={editorState}
        // readOnly={true}
        // toolbarHidden
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        toolbar={{
          inline: { options: ["bold", "italic", "underline"] },
          colorPicker: { className: "demo-color-picker" },
        }}
        // editorStyle={{
        //   background: "white",
        //   minHeight: "200px",
        //   padding: "10px",
        // }}
      /> */}
      {/* </Typography> */}

      <Editor
        editorState={editorState}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        style={{ backgrond: "white" }}
        editorStyle={{
          color: "#164242",
          background: "white",
          height: "200px",
        }}
        toolbarHidden
        readOnly
      />
    </div>
  );
}

export default UniversityOverviewSection;
